import { Dispatch, Middleware } from 'redux';

export const mockStore: { dispatch: Dispatch } = {
    // @ts-expect-error
    dispatch: null
};

export const mockMiddleware: Middleware<object> = () => {
    return function wrapDispatchToMock(next) {
        mockStore.dispatch = function dispatch(action) {
            return next(action);
        };

        vi.spyOn(mockStore, 'dispatch');

        return mockStore.dispatch;
    };
};
